import Tasks from 'APP/Tasks';
import { deleteGroup as deleteGroupModel } from 'APP/model/group/groupModel';
import Entities from 'STORE';

async function request(groupId) {
  try {
    await deleteGroupModel(groupId);
    return {
      error: null,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
}

export async function deleteGroup({ groupId }) {
  if (groupId === Entities.GroupsStore.activeGroupId) {
    Tasks.group.setActiveGroup({ groupId: null });
  }

  const { error } = await request(groupId);

  if (error) {
    return {
      error,
    };
  }

  Tasks.group.removeGroupLocally({ groupId });

  return {
    error: null,
  };
}
